import { MODEL_IDS } from '@/dictionary/modelIds';

export const errorHandler = {
  methods: {
    messageHandler(msg) {
      this.message = msg;
      setTimeout(() => {
        this.message = '';
      }, 3000);
    }
  }
};

export const test = {};

export const modelNumberWithIndividualSectionHeight = {
  data() {
    return {
      modelNumberWithIndividualSectionHeight: [
        MODEL_IDS.rollo,
        MODEL_IDS.panel,
        MODEL_IDS.banner,
        MODEL_IDS.follo
      ]
    };
  }
};
